import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'app-right-panel',
  templateUrl: './right-panel.component.html',
  styleUrls: ['./right-panel.component.scss']
})
export class RightPanelComponent implements OnInit , AfterViewInit {
  panelOpenState = false;
  isFormValid: boolean;
  @Input() vprofile: any;
  @Input() RightNavData: any;
  @Input() userProfile: boolean;
  @Input() findMode: any;
  @Output() closeEvent = new EventEmitter();
  @Output() addUserCloseEvent = new EventEmitter();
  @ViewChild('drawer') drawer;

  constructor(private layoutService: LayoutService) { }

  ngOnInit() {
  }
  ngAfterViewInit() {
  }
  righNavClose() {
    this.RightNavData.toggle();
    this.layoutService.changeActiveValue(true);
    this.layoutService.changeRightNavExp(true);
    this.layoutService.changeFormValidtion(true);

    this.addUserCloseEvent.emit(true);

    // this.validateForm.formValid.subscribe(
    //   data => this.isFormValid = data
    // )
  }
}
